<template>
  <div>
    <div class="page-title">
      <v-icon
        style="color: rgb(177, 204, 99); margin-right: 15px"
        size="20"
        dark
        >far fa-edit</v-icon
      >互動考核
    </div>
    <div id="finish" v-if="isFinish">
      <img src="../assets/Tick.png" />
      <p>恭喜，你已完成評核</p>
      <p>你答對了{{ correctAnswer }}條問題</p>
      <v-btn
        class="select-button"
        outlined
        rounded
        text
        width="100"
        style="margin: 15px 0 15px 0"
        @click="() => this.$router.push('/')"
        >確定</v-btn
      >
    </div>
    <div id="container" v-if="examArray[questionNum - 1]">
      <div class="question_title">
        <div class="question_mid">
          <img src="../assets/Question.png" width="30px" height="28px" />
          <div style="padding-left: 10px">
            Q{{ questionNum }}. {{ examArray[questionNum - 1].questionTitle }}
          </div>
        </div>
        <div class="question_right">{{ questionNum }}/{{ totQuestion }}</div>
      </div>
      <div class="question_img">
        <img
          v-bind:src="
            baseUrl +'image_upload/'+
            examArray[questionNum - 1].image
          "
          width="100%"
        />
      </div>
      <div class="question_selection">
        <v-btn
          class="select-button"
          outlined
          rounded
          block
          large
          text
          @click="checkSelect(questionNum - 1, 0)"
          >A. {{ examArray[questionNum - 1].aAnswer }}</v-btn
        >
        <v-btn
          class="select-button"
          outlined
          rounded
          block
          large
          text
          @click="checkSelect(questionNum - 1, 1)"
          >B. {{ examArray[questionNum - 1].bAnswer }}</v-btn
        >
        <v-btn
          class="select-button"
          outlined
          rounded
          block
          large
          text
          @click="checkSelect(questionNum - 1, 2)"
          >C. {{ examArray[questionNum - 1].cAnswer }}</v-btn
        >
        <v-btn
          class="select-button"
          outlined
          rounded
          block
          large
          text
          @click="checkSelect(questionNum - 1, 3)"
          >D. {{ examArray[questionNum - 1].dAnswer }}</v-btn
        >
      </div>
      <div class="question_next">
        <div class="resultString">{{ resultString }}</div>
        <v-btn
          id="a_se"
          outlined
          rounded
          text
          right
          width="100"
          @click="checkNext(questionNum - 1)"
          >下一題</v-btn
        >
      </div>
    </div>
  </div>
</template>

<style scoped>
#finish {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  margin-top: 20%;
  margin-bottom: 20%;
}
#finish p {
  margin: 5px 0 5px 0;
}
#container {
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 15px;
  padding-bottom: 15px;
}
.page-title {
  background-color: rgb(242, 254, 206);
  padding: 15px 50px 10px 70px;
  font-size: 25px;
  font-weight: bold;
}
.question_title {
  display: flex;
  justify-content: space-between;
  margin: 10px 0 10px 0;
}
.question_title .question_mid,
.question_title .question_right {
  display: flex;
  margin-top: auto;
}

.question_title .question_mid {
  font-size: 23px;
  font-weight: bold;
}
.question_title .question_right {
  font-size: 14px;
  color: rgb(92, 92, 92);
}
.question_img {
  padding: 10px 0 10px 0;
}
.question_selection .v-btn {
  margin: 5px 0 15px 0;
}
.question_selection .v-btn >>> .v-btn__content {
  justify-content: left;
}
.question_next {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.resultString {
  padding: 0 15px 0 15px;
}
</style>

<script>
export default {
  data() {
    return {
      isFinish: false,
      examArray: [],
      questionNum: 1,
      totQuestion: 1,
      correctAnswer: 0,
      isClick: false,
      resultString: "",
      baseUrl: ''
    };
  },
  methods: {
    getBaseUri () {
      this.axios
        .get("/api/api.php?p=data/baseUrl")
        .then((response) => {
          this.baseUrl = response.data.sdata["url"];
          // console.log(this.baseUrl);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    checkSelect(questionNum, select) {
      if (this.isClick) {
        return 0;
      }
      // console.log(document.getElementsByClassName("select-button"));

      if (this.examArray[questionNum]["currentAnswer"] == select.toString()) {
        this.correctAnswer = this.correctAnswer + 1;
        //next button left text change
        this.resultString = "正確！下一題";

        //correct button background color change
        document.getElementsByClassName("select-button")[
          select
        ].style.backgroundColor = "rgb(170,206,80)";
        //correct button text color change
        document.getElementsByClassName("select-button")[
          select
        ].style.borderColor = "white";

        //console log testing
        // console.log("correct");
      } else {
        //next button left text change
        const litter =
          this.examArray[questionNum]["currentAnswer"] == 0
            ? "A"
            : this.examArray[questionNum]["currentAnswer"] == 1
            ? "B"
            : this.examArray[questionNum]["currentAnswer"] == 2
            ? "C"
            : "D";
        this.resultString = "答錯了，正確答案是" + litter;

        //wrong button boarder color change
        document.getElementsByClassName("select-button")[
          select
        ].style.borderColor = "red";

        //correct button background color change
        document.getElementsByClassName("select-button")[
          this.examArray[questionNum]["currentAnswer"]
        ].style.backgroundColor = "rgb(170,206,80)";
        //correct button text color change
        document.getElementsByClassName("select-button")[
          this.examArray[questionNum]["currentAnswer"]
        ].style.color = "white";
      }
      this.isClick = true;
    },
    checkNext(questionNum) {
      if (!this.isClick) {
        //not select answer
        this.resultString = "請選擇答案";
      } else if (this.totQuestion - questionNum != 1) {
        //already select answer
        this.questionNum = this.questionNum + 1;
        this.resetQuestion();
      } else {
        //finish exam
        // console.log("finish exam");
        document.getElementById("container").style.display = "none";
        this.isFinish = true;
      }
    },
    resetQuestion() {
      // border-color: rgba(0, 0, 0, 0.12);
      document.getElementsByClassName("select-button").forEach((btn) => {
        btn.style.borderColor = "rgba(0, 0, 0, 0.12)";
        btn.style.backgroundColor = "white";
        btn.style.color = "black";
      });
      this.resultString = "";
      this.isClick = false;
    },
    async getexamData() {
      await this.axios({
        method: "post",
        url: "/api/api.php?p=data/exam",
      })
        .then((response) => {
          // console.log(response);
          this.examArray = response.data.sdata["data"];
          this.totQuestion = response.data.sdata["numRow"];
          //date
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
      // console.log(this.examArray);
      //exam data post
    },
  },
  mounted() {
    this.getBaseUri();
    this.getexamData();
  },
};
</script>